exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.size-tabela[data-v-16177a0a]{\r\n    width: 700px;\n}\r\n\r\n", ""]);

// exports
